import moment from 'moment';
import {
  chartChartConfig,
  chartCommonConfig,
  chartTitleConfig,
  chartLineExportingConfig,
  chartLineColorsConfig,
  chartLineXaxisConfig,
  chartYaxisConfig,
  axisLablesFontSizeSet
  // chartLineTooltipConfig
} from '../../../config/chartCommon';
import { roundToTwoDecimal } from '../../../utilities/common.computations';

function processInstantaneousPowerChartConfig(
  chartApiData,
  graphFilter,
  graphName,
  userAccessibility,
  graphTooltip,
  setProcessedXAxis,
  setMinMaxValue
) {

 
  const isOperator = localStorage.getItem('is_operator') === 'true';
  const normalizedSeries = (() => {
  // New API (array of series)
  if (Array.isArray(chartApiData)) {
   // console.log("array")
    return chartApiData.map(item => ({
      name: item?.data_points?.name,
      data: item?.data_points?.data ||item?.data_points|| [],
      unit_name: item?.unit_name
    }));
  }

  // Old API (single series)
  if (chartApiData?.data_points) {
   // console.log("notarray")
    return (chartApiData?.data_points || []);
  }

  return [];
})();

const dataPoints = normalizedSeries;



function splitTextStrictWithIndent(text, maxChars = 15) {
  const lines = text.split('\n');
  let result = [];
  
  for (const line of lines) {
      // Skip empty lines
      if (line.trim() === '') continue;
      
      // Handle indented lines (starting with "-")
      if (line.trim().startsWith('-')) {
          const indent = '&nbsp;&nbsp;';
          result.push(indent + line.trim());
          continue;
      }
      
      // Handle normal lines
      const words = line.trim().split(' ');
      let currentLine = '';
      
      for (const word of words) {
          if (currentLine.length + word.length <= maxChars) {
              currentLine += (currentLine ? ' ' : '') + word;
          } else {
              if (currentLine) result.push(currentLine);
              currentLine = word;
          }
      }
      
      if (currentLine) {
          result.push(currentLine);
      }
  }
  
  return result.join('<br>');
}
 // Calculate if legend can fit horizontally
 function canFitHorizontally(dataPoints) {
  // Convert to array if it's an object
  const pointsArray = dataPoints && typeof dataPoints === 'object' && !Array.isArray(dataPoints)
    ? Object.values(dataPoints)
    : Array.isArray(dataPoints) ? dataPoints : [];

  if (pointsArray.length === 0) return true;

  const MAX_HORIZONTAL_ITEMS = 6;
  const MAX_TOTAL_WIDTH = 2060;
  const ITEM_WIDTH = 300;

  if (pointsArray.length > MAX_HORIZONTAL_ITEMS) return false;

  const hasVeryLongItems = pointsArray.some(
    point => point?.name?.length > 60
  );

  const estimatedWidth = pointsArray.reduce((sum, point) => {
    const length = point?.name?.length || 0;
    return sum + ITEM_WIDTH * (length > 30 ? 1.5 : 1);
  }, 0);

  return !hasVeryLongItems && estimatedWidth < MAX_TOTAL_WIDTH;
}
  
  //chartApiData?.data_points?.length > 6
  const canFitHorizontal = canFitHorizontally(dataPoints)
  const isVerticalLayout = !canFitHorizontal;


  const config = {
    ...chartTitleConfig({
      graphTitle: graphName,
      userAccessibility: userAccessibility,
      graphTooltip: graphTooltip
    }),
    ...chartLineColorsConfig,
    ...chartCommonConfig,
    ...chartLineExportingConfig,
    chart: {
      ...chartChartConfig({ userAccessibility: userAccessibility }),
      spacingBottom: 20
    },

    ...chartLineXaxisConfig({
      graphFilter: graphFilter,
      userAccessibility: userAccessibility,
      setMinMaxValue: setMinMaxValue
    }),
    ...chartYaxisConfig({ userAccessibility: userAccessibility }),
    tooltip: {
      formatter: function () {
        let date = ` <div>${
          graphFilter?.filterMain === '1year'
            ? moment(this.point.x).format('ddd, DD MMM YYYY, HH:mm')
            : moment(this.point.x).format('ddd, DD MMM, HH:mm')
        }<div>`;
        let name = `     <span style="color:${this.color}">\u25CF </span>
        <div>${this.series.name}:</div> 
        <span class="semi-bold">${roundToTwoDecimal(this.y)} ${
          chartApiData.unit_name
            ? chartApiData.unit_name
            : this.series.userOptions.unit_name
            ? this.series.userOptions.unit_name
            : ' kW'
        }</span><br/>`;
        return `<div>
          <div>${date}</div></br><div>${name}</div>
          </div>`;
      }
    },
    plotOptions: {
      series: {
        lineWidth: 2,

        type: 'line',
        marker: {
          enabled: false
        },

        dataGrouping: {
          enabled: false
        },
        showInLegend: true
      }
    },

    exporting: {
      allowHTML: true,
      chartOptions: {
        legend: {
          enabled: false // Disable legend in exported charts
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          }
        }
      }
      //fallbackToExportServer: false
    },
    legend: {
      enabled: isOperator,
      layout: isVerticalLayout ? 'vertical' : 'horizontal',
      align: isVerticalLayout ? 'right' : 'center',
      verticalAlign: isVerticalLayout ? 'top' : 'bottom',
      maxHeight: isVerticalLayout?undefined:55,
      padding:isVerticalLayout?undefined:-6,
      margin: 20,
      itemMarginRight: 19,
      symbolHeight: 14,
      symbolWidth: 15,
      y: 10,
      x: 10,
      useHTML: false,
      itemStyle: {
        cursor: 'pointer',
        color: '#333333',
        fontSize: axisLablesFontSizeSet(userAccessibility)
      },
      labelFormatter: function () {
        if (!isVerticalLayout) {
          return this.name;
        }
        return splitTextStrictWithIndent(this.name);
      },
      navigation: {
        activeColor: '#212529;',
        animation: true,
        arrowSize: 12,
        inactiveColor: '#CCC',
        style: {
          fontWeight: 'bold',
          color: '#333',
          fontSize: '12px'
        }
      },
    },

    series:  normalizedSeries
  
  };

  return config;
}

export default processInstantaneousPowerChartConfig;
